import React from 'react';
import { Box, Paper } from '@mui/material';

export const DashboardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ p: { xs: 1, md: 2 }, backgroundColor: 'var(--grayWhite, #f1f1f1)', minHeight: '100vh' }}>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, display: 'flex', flexDirection: 'column', gap: 2, backgroundColor: '#ffffff' }}>
        {children}
      </Paper>
    </Box>
  );
};